import cx from 'classnames';
import Container from 'modules/common/Container';
import TrailerPlay from 'modules/common/Svg/TrailerPlay';
import NewDesignButton from 'modules/common/NewDesignButton';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import Programmers from 'theme/assets/images/programmers.svg';
import ListIcon from 'theme/assets/images/list.svg';
import TableIcon from 'theme/assets/images/table.svg';
import {
  trailerPlay,
  coursesContainer,
  discordlink,
  heroContainer,
  heroButtons,
  viewSchedule,
} from './styles.scss';

const HeroBox = ({
  title,
  metas,
  children,
  className,
  description,
  background,
  video,
  onVideoClick,
  join_count,
  cyTitle,
  isDegree,
  isCoursesPage,
  isBootcampsPage,
}) => {
  return (
    <div className={`relative w-100 pv4 tr-ns tc ${className}`}>
      {background && (
        <div
          className="absolute top-0 w-100 h-100 o-10 cover bg-top"
          style={{
            backgroundImage: `url('${background}')`,
            backgroundPositionY: isDegree ? 'center' : 'auto',
          }}
        />
      )}
      <Container>
        <div
          className={
            isDegree && isBootcampsPage
              ? `flex items-center justify-between ${heroContainer}`
              : 'block'
          }
        >
          <div
            className={
              isCoursesPage
                ? `relative flex items-center justify-between ${coursesContainer}`
                : 'relative'
            }
          >
            <header
              className={cx('relative pv2 white', {
                'w-50-ns pl5-m w-100-m': video,
              })}
            >
              {join_count > 0 && (
                <div className="dib normal white pv2 ph3 bg-white-20 br-pill bn mb3 tr-ns tc">
                  <div className="flex items-center">
                    <img className="ml2" src={Programmers} alt="programmers" />
                    <FormattedMessage id="join" />
                    <span className="mh1">{join_count}</span>
                    <FormattedMessage id="programmer" />
                  </div>
                </div>
              )}
              <h1
                className={cx('f3', {
                  tc: isDegree,
                })}
                data-cy={cyTitle}
              >
                {title}
              </h1>
              {video && (
                <button
                  aria-label="Trailer play button"
                  className={`grow pointer bg-transparent pa0 bn absolute-ns left-0 ${trailerPlay}`}
                  onClick={onVideoClick}
                >
                  <TrailerPlay height={40} width={40} />
                </button>
              )}
            </header>
            {!isDegree && description && (
              <p
                className="mv3 mb1 white"
                dangerouslySetInnerHTML={{__html: description}}
              />
            )}
            {children && <div className="pv2 cf">{children}</div>}
          </div>
          <div className="relative">
            {!isDegree && metas && <div className="pb0-l pb2-m">{metas}</div>}
          </div>
          {isDegree && isBootcampsPage && (
            <div
              className={`relative flex items-center justify-between white ${heroButtons}`}
            >
              <NewDesignButton
                className={`lh-copy ph3 ${discordlink} bg-blue bg-animate hover-bg-dark-blue`}
                link="https://discord.gg/qmVqWbm"
                external
              >
                <FormattedMessage id="do_you_need_help" />
              </NewDesignButton>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

HeroBox.defaultProps = {
  className: '',
  background: '',
  video: false,
};

HeroBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  description: PropTypes.string,
  metas: PropTypes.node,
  className: PropTypes.string,
  background: PropTypes.string,
  video: PropTypes.bool,
  onVideoClick: PropTypes.func,
  join_count: PropTypes.number,
  cyTitle: PropTypes.string,
  isDegree: PropTypes.bool,
  isCoursesPage: PropTypes.bool,
  isBootcampsPage: PropTypes.bool,
  isBootcampEventsVisible: PropTypes.bool,
  toggleBootcampEvents: PropTypes.func,
};

export default HeroBox;
